<template>
  <div>
    <PageHeader title="Challenges">
      <CreateButton @click="createChallengeModalOpen = true">Créer un challenge</CreateButton>
    </PageHeader>
    <Modal :open="createChallengeModalOpen" @close="createChallengeModalOpen = false">
      <div class="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-primary-light">
        <DocumentReportIcon class="h-6 w-6 text-green-600" aria-hidden="true" />
      </div>
      <ChallengeNewForm @success="challengeCreated" />
    </Modal>

    <ChallengeList :challenges="challenges" @refreshChallenges="retrieveChallenges" />
    <Pagination :currentPage="currentPage" :totalPages="totalPages" :totalCount="totalCount" @changePage="updatePage" />
  </div>
</template>

<script>
import { CreateButton, Modal, PageHeader, Pagination } from "@estaly/ui";
import ChallengeList from "@/components/challenge/ChallengeList.vue";
import ChallengeNewForm from "@/components/challenge/ChallengeNewForm.vue";
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import { DocumentReportIcon } from "@heroicons/vue/outline";

export default {
  components: {
    PageHeader,
    Modal,
    Pagination,
    ChallengeList,
    ChallengeNewForm,
    CreateButton,
    DocumentReportIcon,
  },
  data() {
    return {
      createChallengeModalOpen: false,
    };
  },
  computed: {
    ...mapGetters("challenges", { challenges: "getIndex" }),
    ...mapState("challenges", ["currentPage", "totalPages", "totalCount"]),
  },
  async mounted() {
    await this.retrieveChallenges();
  },
  methods: {
    ...mapActions("challenges", ["fetchIndex"]),
    ...mapMutations("challenges", ["setCurrentPage"]),
    async challengeCreated() {
      this.createChallengeModalOpen = false;
      await this.retrieveChallenges();
    },
    async retrieveChallenges() {
      await this.fetchIndex({ includes: ["sales_targets", "organizations"], page: this.currentPage });
    },
    updatePage(page) {
      this.setCurrentPage(page);
      this.retrieveChallenges();
    },
  },
};
</script>
